export default __webpack_public_path__ + "static/media/sidebar-4.3217882d.jpg";